import { useState } from 'react';
import { translate } from 'react-switch-lang';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { Practice } from '../../model/types';
import PracticeForm from './PracticeForm';

interface CreatePracticeProps {
  setPractices: React.Dispatch<React.SetStateAction<Practice[]>>;
  createPractice: (data: Practice) => Promise<any>;
  t: (key: string) => string;
}

const CreatePractice = ({ setPractices, createPractice, t }: CreatePracticeProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: Practice) => {
    setIsLoading(true);
    const response = await createPractice({ ...data, active: data.active ?? true });
    setIsLoading(false);

    if (response?.status === 201) {
      setPractices((prev) => [...prev, { ...data, id: response.data }]);
      setIsOpen(false);
      SweetAlert.fire(t('practice.created'), t('practice.practice_created'), 'success');
    } else {
      SweetAlert.fire(t('practice.error'), t('practice.err'), 'error');
    }
  };

  return (
    <>
      <Button outline color="success" onClick={() => setIsOpen(true)}>
        {t('practice.add_practice')}
      </Button>

      <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered>
        <ModalHeader toggle={() => setIsOpen(false)}>{t('practice.add_practice')}</ModalHeader>
        <ModalBody>
          <PracticeForm
            defaultValues={{ active: true } as Practice}
            onSubmit={onSubmit}
            onCancel={() => setIsOpen(false)}
            isLoading={isLoading}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreatePractice);
